'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumSuccess = ({ testId, className, solid })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? jsxRuntime.jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM11.4788 5.48931C11.7608 5.75373 11.7751 6.19671 11.5107 6.47875L7.76073 10.4787C7.63328 10.6147 7.4569 10.6942 7.27065 10.6997C7.08439 10.7052 6.90364 10.6362 6.76842 10.508L4.51842 8.37463C4.23788 8.10863 4.22608 7.66557 4.49208 7.38503C4.75808 7.10448 5.20114 7.09269 5.48168 7.35869L7.22084 9.00767L10.4894 5.52123C10.7538 5.23919 11.1968 5.2249 11.4788 5.48931Z",
            fill: "currentColor"
        }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [
                jsxRuntime.jsxs("g", {
                    clipPath: "url(#clip0_4702_5935)",
                    children: [
                        jsxRuntime.jsx("circle", {
                            cx: "8",
                            cy: "8",
                            r: "7.3",
                            stroke: "currentColor",
                            strokeWidth: "1.4",
                            strokeLinejoin: "round"
                        }),
                        jsxRuntime.jsx("path", {
                            d: "M5 7.86667L7.25 10L11 6",
                            stroke: "currentColor",
                            strokeWidth: "1.4",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                }),
                jsxRuntime.jsx("defs", {
                    children: jsxRuntime.jsx("clipPath", {
                        id: "clip0_4702_5935",
                        children: jsxRuntime.jsx("rect", {
                            width: "16",
                            height: "16",
                            fill: "white"
                        })
                    })
                })
            ]
        })
    });
};

module.exports = MediumSuccess;
